// Ghost mascot sprite sheet configuration
// 6x6 grid with different variants per row

export const GHOST_SPRITE_CONFIG = {
  src: '/sprites/ghost-6x6-clean.avif',
  cols: 6,
  rows: 6,
  frameWidth: 192,
  frameHeight: 192,
  totalFrames: 36,
  fps: 8,
} as const;

// Each row is a different variant/pose
export const ANIMATION_ROWS = {
  idle: 0, // Row 0: Neutral with glasses
  happy: 1, // Row 1: Happy, closed eyes, sparkles
  calculating: 2, // Row 2: With abacus (matches logo!)
  waving: 3, // Row 3: Hand up waving
  thinking: 4, // Row 4: Thought bubble
  thumbsup: 5, // Row 5: Thumbs up
} as const;

export type AnimationVariant = keyof typeof ANIMATION_ROWS;

// Section-to-variant mapping for landing page
const SECTION_VARIANTS: Record<string, AnimationVariant> = {
  hero: 'waving',
  features: 'calculating',
  pricing: 'happy',
  cta: 'waving',
  faq: 'idle',
  divider: 'idle',
};

// Feature icons (3x3 grid) - clean version matching ghost mascot style
export const FEATURE_ICONS = {
  src: '/sprites/feature-icons-v10.webp',
  cols: 3,
  rows: 3,
  variants: {
    receipt: { col: 0, row: 0 }, // Ghost with receipt
    taxFiling: { col: 1, row: 0 }, // Ghost with calculator
    expense: { col: 2, row: 0 }, // Ghost with money/coins
    reporting: { col: 0, row: 1 }, // Ghost reading book
    cloud: { col: 1, row: 1 }, // Ghost with cloud
    paychecks: { col: 2, row: 1 }, // Ghost with cash stack
    payroll: { col: 0, row: 2 }, // Ghost with clipboard
    invoicing: { col: 1, row: 2 }, // Ghost with invoice
    bank: { col: 2, row: 2 }, // Ghost with bank
  },
} as const;

export type FeatureIconVariant = keyof typeof FEATURE_ICONS.variants;
